export default __webpack_public_path__ + "static/media/tranings_no_image_3.e0a0cf5e.svg";